export function isDictsysFormat(methodId: string): boolean {
  if (!methodId.startsWith("ordbogen-")) {
    return false;
  }

  if (methodId === "ordbogen-daar" || methodId === "ordbogen-arda") {
    return false;
  }

  if (methodId === "ordbogen-klkl") {
    return false;
  }

  return true;
}

export function isGyldendalFormat(methodId: string): boolean {
  if (!methodId.startsWith("gyldendal-")) {
    return false;
  }

  if (methodId === "gyldendal-red-daru" || methodId === "gyldendal-red-ruda") {
    return false;
  }

  return true;
}
